const FixedFooter = () => {
  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-zinc-800 border-t border-zinc-700 z-50">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-center">
          <p className="text-white text-sm font-medium">
            2025 © Staffing Solutions LLC
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FixedFooter;
